import React from 'react';

import { Container, Title } from './styles';

export default function BtnSecondary({ title, type, to, onClick, styles }) {
  return (
    <Container type={type} to={to} onClick={onClick} styles={styles}>
      <Title>{title}</Title>
    </Container>
  );
}
